import React, { useState } from "react";

import styles from './View.Style';
import withStyles from '@material-ui/core/styles/withStyles';

import DeleteIcon from '@material-ui/icons/Delete'
// import AddIcon from '@material-ui/icons/Add';
import VisibilityIcon from '@material-ui/icons/Visibility';
import StarIcon from '@material-ui/icons/Star';
const TableCard = props => {
  const {
    classes,
    title,
    header,
    data,
    onClick,
    disabled,
    onShowAll,
    hideShowAll = false,
    isAdmin,
    isOrganizer,
    isInnovator,
    isEvaluator,
    HideEyeIconForOtherEvaluator,
    loginUserEmail,
  } = props

  const rowsToRender = !hideShowAll ? data.slice(0, 3) : data;
  
  const listItems = rowsToRender.map((row) => {

    // 1. If admin, they bypass the email check completely. 
    // 2. Otherwise, innovators or approved evaluators must match the row's email.
    const showEyeIconForThisRow = isAdmin || isInnovator || isOrganizer || (
      ((isEvaluator && HideEyeIconForOtherEvaluator)) && 
      (row.userEmail === loginUserEmail)
    );
    return (
      <tr key={row.userEmail} className={classes.tableBodyRow}>
        <td className={classes.td}>{row.userEmail}</td>

        {header.length > 2 && (
          <td className={classes.rankingTd}>
            <StarIcon className={classes.starIcon} />
            {row.ideaRating === "" ? "0" : row.ideaRating}/100%
          </td>
        )}
    
        <td className={classes.iconWrapper}>
          {header.length > 2 ? (
            /* 4. Only render the button if it matches the current user's email */
            showEyeIconForThisRow && (
              <button type='button' onClick={() => onClick(row)} disabled={disabled}>
                <VisibilityIcon className={classes.icon} alt="View details" /> 
              </button>
            )
          ) : (
            (isAdmin || isInnovator || isOrganizer) && (
              <button type='button' onClick={() => onClick(row)} disabled={disabled}>
                <DeleteIcon className={classes.icon} alt="Delete" />
              </button>
            )
          )}
        </td>
      </tr>
    );
  });

  const tableHeader = header.map(h => <th key={h} className={classes.th}>{h}</th>)

  return (
    <div className={classes.container}>
      {!hideShowAll && <p className={classes.heading}>{title}</p>}
      <table className={classes.table}>
        <thead>
          <tr className={classes.tableHeaderRow}>
            {tableHeader}
          </tr>
        </thead>
        <tbody>
          {listItems}
        </tbody>
      </table>
      {!hideShowAll && data.length > 3 && (
        <div className={classes.buttonWrapper}>
          <button type="button" onClick={onShowAll}>View all</button>
        </div>
      )}
    </div>
  )
}

export default withStyles(styles)(TableCard)